/**
 * Enum for measurement filter categories
 */
export enum MeasurementFilterCategory {
    FirstAmplitude = 0,
    LastAmplitude = 1,
    FirstResult = 2,
    LastResult = 3,
    PtcUse = 4
}
